export const SupplierHistoryValidation = (formData) => {
    const errors = {};

    if (!formData.dt_Created || !formData.dt_Created.trim()) {
        errors.dt_Created = 'This field is required';
    }



    if (!formData.FK_SupplierContact_ID || formData.FK_SupplierContact_ID === "0") {
        errors.FK_SupplierContact_ID = 'This field is required';
    }

    if (!formData.vc_Description || formData.vc_Description === "0") {
        errors.vc_Description = 'This field is required';
    }
    if (formData.snt_CommunicationType === 1 || formData.snt_CommunicationType === "1") {
        if (!isValidEmail(formData.vc_From)) {
            errors.vc_From = 'Please enter a valid email address';
        }
        if (!isValidEmail(formData.vc_To)) {
            errors.vc_To = 'Please enter a valid email address';
        }
        if (formData.vc_CC) {
            if (!isValidEmail(formData.vc_CC)) {
                errors.vc_CC = 'Please enter a valid email address';
            }
        }
        if (!formData.vc_Subject || !formData.vc_Subject.trim()) {
            errors.vc_Subject = 'This field is required';
        }
    }

    return errors;
};
const isValidEmail = (email) => {
    // You can implement a regex or use a library like validator.js to validate email format
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
